/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Checklist202,
  PostApiV1Checklist400,
  PostApiV1Checklist401,
  PostApiV1Checklist409,
  PostApiV1Checklist500,
  PostApiV1ChecklistMutationRequest,
  PostApiV1ChecklistMutationResponse,
} from "../../types/checkListRegistroController/PostApiV1Checklist.ts";
import { checkListViewModelSchema } from "../checkListViewModelSchema.ts";
import { createCheckListRequestViewModelSchema } from "../createCheckListRequestViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Checklist202Schema = z.lazy(
  () => checkListViewModelSchema,
) as unknown as ToZod<PostApiV1Checklist202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Checklist400Schema =
  z.any() as unknown as ToZod<PostApiV1Checklist400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Checklist401Schema =
  z.any() as unknown as ToZod<PostApiV1Checklist401>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1Checklist409Schema =
  z.any() as unknown as ToZod<PostApiV1Checklist409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Checklist500Schema =
  z.any() as unknown as ToZod<PostApiV1Checklist500>;

export const postApiV1ChecklistMutationRequestSchema = z.lazy(
  () => createCheckListRequestViewModelSchema,
) as unknown as ToZod<PostApiV1ChecklistMutationRequest>;

export const postApiV1ChecklistMutationResponseSchema = z.lazy(
  () => postApiV1Checklist202Schema,
) as unknown as ToZod<PostApiV1ChecklistMutationResponse>;
